import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiWallet } from 'react-icons/pi';
import { IAdvance } from 'services/advance/types';

const AdvanceData = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, status } = useFormikContext<IAdvance>();

  const boolOptions = [
    { value: true, label: t(`enum.LABEL_REPAYMENTS.Yes`) },
    { value: false, label: t(`enum.LABEL_REPAYMENTS.No`) },
  ];
  return (
    <DataWrapper>
      <Container>
        <Container.Header
          title={
            <>
              <PiWallet /> {t('cash-flow.tabs.data')}
            </>
          }
        />
        <Container.Content className="w-full items-center">
          <FormInput.Number
            name="amount"
            label={t('input.label.amount')}
            placeholder={`0 ${'PLN'}`}
            suffix={` ${'PLN'}`}
          />
          <FormInput.Number
            name="maximumRepaymentPercentage"
            label={t('input.label.maximumRepaymentPercentage')}
            placeholder="0 %"
            suffix=" %"
          />
          <FormInput.Select
            name="settlementPeriodId"
            label={t('input.label.settlementPeriodId')}
            value={
              values.settlementPeriod
                ? {
                    value: values.settlementPeriodId,
                    label: `${values.settlementPeriod.name} ${values.settlementPeriod.year}`,
                  }
                : undefined
            }
            isAsync
          />
          <FormInput.Select
            label={t('input.label.repaymentsFromAllContracts')}
            name="repaymentsFromAllContracts"
            options={boolOptions}
          />

          <FormInput.Text name="date" type="date" label={t('input.label.date')} />

          <FormInput.Number
            name="remainingNetAmount"
            label={t('input.label.remainingNetAmount')}
            suffix={` ${'PLN'}`}
          />
        </Container.Content>
      </Container>
    </DataWrapper>
  );
};

export default AdvanceData;
